import React from 'react';
import {WF_BINDING_DATA_KEY} from '@packages/systems/commerce/constants';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, withSystem, Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TBoolean, TListOfElement} from '@packages/systems/wfdl-ast';

const CommerceCartOptionListItemLabel = Atom.createRender((props) => {
  const {attributes, classes, context, generateAttributes, innerHTML} = props;
  const label = context.get('label', '');
  const newAttributes = {
    ...generateAttributes(attributes, classes),
    [WF_BINDING_DATA_KEY]: encodeURIComponent(
      JSON.stringify([
        {
          innerHTML: {
            type: 'PlainText',
            filter: {type: 'identity', params: []},
            dataPath: context
              .get('bindingPathPrefix', [])
              .concat(['name'])
              .join('.'),
          },
        },
      ])
    ),
  } as const;
  return (
    <span {...newAttributes}>
      {innerHTML
        ? // TODO (platform): fix innerHTML type issues

          innerHTML
        : label}
    </span>
  );
});

const config = createIntegratedAtom({
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  displayName: 'Text Block',
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: 'CommerceCartOptionListItem',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: CommerceCartOptionListItemLabel,
  fields: {
    text: withSystem({private: true}, TBoolean),
    children: TListOfElement,
  },
});

export default config;
